module.exports = __webpack_public_path__ + "static/media/flower.db62e71e.png";